module.exports = __webpack_public_path__ + "img/icon-check2.68881bd3.svg";